import { Component } from '@angular/core';

@Component({
    selector: 'yougiver-sign-in-seller',
    template: require('./sign-in-seller.component.pug')
})
export class SignInSellerComponent {

}
